module.exports = __webpack_public_path__ + "media/images/landing/people-0439151a58c6d4565b724182de4bdb08.png";